/**
 * 공용 색상 팔레트(툴바 스와치용) — FloatingMenu·서식 팝업 툴바 공유.
 * [value, displayHex] 배열. value 는 BlockNote named 색(default/gray/…), hex 는 스와치 표시색.
 * (표 셀 색상은 table-controls.js 의 HEX/TEXT_HEX 맵을 별도 사용)
 */
export const TEXT_PALETTE = [
  ["default", ""], ["gray", "#9b9a97"], ["brown", "#64473a"], ["red", "#e03e3e"], ["orange", "#d9730d"],
  ["yellow", "#dfab01"], ["green", "#4d6461"], ["blue", "#0b6e99"], ["purple", "#6940a5"], ["pink", "#ad1a72"],
];
export const BG_PALETTE = [
  ["default", ""], ["gray", "#ebeced"], ["brown", "#e9e5e3"], ["red", "#fbe4e4"], ["orange", "#f6e9d9"],
  ["yellow", "#fbf3db"], ["green", "#ddedea"], ["blue", "#ddebf1"], ["purple", "#eae4f2"], ["pink", "#f4dfeb"],
];
